import Children from '../../../../layouts/Children.vue';

const routes = [
  {
    path: 'devices',
    component: Children,

    children: [
      {
        path: '',
        name: 'devices',
        component: () => import('../pages/DevicesPage.vue')
      }
    ]
  }
];

export default routes;
